"use client";
import i from "styled-components";
import t from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import l from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import { toRgba as c, icons as a } from "./index.es99.js";
import u from "./index.es100.js";
import { Donut as p } from "./index.es101.js";
const m = i.div`
  svg {
    fill: ${(e) => c(e.iconColor)};
  }
`, d = i(m)`
  .st0 {
    opacity: 0.4;
  }
  display: flex;
  justify-content: center;
  height: 8.175rem;

  & > div {
    height: 8.175rem;
    width: 14.9rem;
  }
`, f = i.div`
  text-align: center;
`, s = ({ variant: e, color: n, value: o }) => {
  const r = u?.[e]?.[o];
  return r ? /* @__PURE__ */ t.createElement(d, { iconColor: n }, /* @__PURE__ */ t.createElement("div", null, r)) : /* @__PURE__ */ t.createElement(t.Fragment, null);
}, E = (e) => {
  if (e.type === "icon") {
    const n = a[e.icon];
    return /* @__PURE__ */ t.createElement(m, { iconColor: e.color }, n);
  }
  return e.type === "donut" ? /* @__PURE__ */ t.createElement(p, { ...e }) : e.type === "nummberInTen" ? /* @__PURE__ */ t.createElement(
    s,
    {
      color: e.color,
      variant: e.variant,
      value: e.value
    }
  ) : /* @__PURE__ */ t.createElement(t.Fragment, null);
}, L = ({ points: e }) => /* @__PURE__ */ t.createElement("div", { className: "bl-container bl-container--small bl-m-y-5" }, /* @__PURE__ */ t.createElement("div", { className: "bl-grid bl-grid--three-columns" }, e.map((n, o) => {
  const r = `main-point-${o}`;
  return /* @__PURE__ */ t.createElement("div", { key: r }, n.type !== "notfound" && /* @__PURE__ */ t.createElement("figure", null, /* @__PURE__ */ t.createElement("div", { className: "bl-m-b-3" }, /* @__PURE__ */ t.createElement(E, { ...n })), /* @__PURE__ */ t.createElement(f, null, /* @__PURE__ */ t.createElement(l, { keyContext: r, content: n.text }))));
})));
export {
  L as default
};
//# sourceMappingURL=index.es48.js.map
